import "react";
import { jsx as e, jsxs as t } from "react/jsx-runtime";
//#region src/components/atoms/Icon/SVGs/thumbUp.svg
var n = (n) => /* @__PURE__ */ t("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 16 16",
	...n,
	children: [/* @__PURE__ */ e("mask", {
		id: "mask0_27462_33636",
		width: 16,
		height: 16,
		x: 0,
		y: 0,
		maskUnits: "userSpaceOnUse",
		style: { maskType: "alpha" },
		children: /* @__PURE__ */ e("rect", {
			width: 16,
			height: 16,
			fill: "#d9d9d9"
		})
	}), /* @__PURE__ */ e("g", {
		mask: "url(#mask0_27462_33636)",
		children: /* @__PURE__ */ e("path", {
			fill: "#fff",
			d: "M14 5.333q.534 0 .934.4t.4.933V8a1.4 1.4 0 0 1-.1.5l-2 4.7q-.15.332-.5.566A1.3 1.3 0 0 1 12 14H6.667q-.55 0-.942-.392a1.28 1.28 0 0 1-.391-.942V5.883q0-.267.108-.508.109-.242.292-.425l3.616-3.6q.25-.234.592-.284t.658.117q.317.167.459.467.14.3.058.616l-.75 3.067zM2.667 14q-.55 0-.942-.392a1.28 1.28 0 0 1-.392-.942v-6q0-.55.392-.941.391-.393.942-.392.55 0 .942.392.39.391.391.941v6q0 .55-.392.942a1.28 1.28 0 0 1-.941.392"
		})
	})]
});
//#endregion
export { n as default };
